import React from 'react';
import { useNavigate } from 'react-router-dom';
import './BowlingStats.css';

const BowlingStats = ({ players }) => {
  const navigate = useNavigate();

  if (!players || players.length === 0) {
    return <div className="no-data">No bowling statistics available</div>;
  }

  const handlePlayerClick = (playerName) => {
    navigate(`/player/${encodeURIComponent(playerName)}/bowling`);
  };

  return (
    <div className="stats-table-container">
      <table className="stats-table">
        <thead>
          <tr>
            <th className="col-rank">#</th>
            <th className="col-name">Player</th>
            <th className="col-matches">M</th>
            <th className="col-overs">Overs</th>
            <th className="col-maidens">Maidens</th>
            <th className="col-runs-conceded">Runs</th>
            <th className="col-wickets">Wickets</th>
            <th className="col-avg">Avg</th>
            <th className="col-economy">Economy</th>
            <th className="col-best">Best</th>
          </tr>
        </thead>
        <tbody>
          {players.map((player, index) => (
            <tr key={`${player.playerName}-${index}`} className={index % 2 === 0 ? 'even' : 'odd'}>
              <td className="col-rank">{index + 1}</td>
              <td 
                className="col-name clickable"
                onClick={() => handlePlayerClick(player.playerName)}
              >
                <span className="player-name">{player.playerName}</span>
              </td>
              <td className="col-matches">{player.matches}</td>
              <td className="col-overs">{player.overs}</td>
              <td className="col-maidens">{player.maidens}</td>
              <td className="col-runs-conceded">{player.runsConceded}</td>
              <td className="col-wickets">
                <span className="stat-value wickets">{player.wickets}</span>
              </td>
              <td className="col-avg">{player.avg}</td>
              <td className="col-economy">{player.economy}</td>
              <td className="col-best">{player.bestFigures}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BowlingStats;
